import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from './lib/utils';
const buttonVariants = cva('inline-flex items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0', {
    variants: {
        variant: {
            // Translucent purple glass CTA — template `galaxy-interactive-
            // hero-section` Start-Free-Trial button. #8200DB at 16% alpha
            // with a #322D36 hairline border and backdrop-blur(8px).
            default: 'bg-[#8200DB29] text-white font-semibold border border-[#322D36] backdrop-blur-md hover:bg-black/50 transition-colors duration-300',
            // Alias retained so existing call sites that used hero-gradient
            // still render cleanly with the new translucent-purple variant.
            'hero-gradient': 'bg-[#8200DB29] text-white font-semibold border border-[#322D36] backdrop-blur-md hover:bg-black/50 transition-colors duration-300',
            destructive: 'bg-destructive text-destructive-foreground shadow-lg shadow-destructive/20 hover:bg-destructive/90',
            // "Watch the Video" style — near-black glass with grey border
            outline: 'bg-black/60 border border-gray-600 text-gray-200 hover:border-gray-400 hover:text-white backdrop-blur-sm transition-colors duration-300',
            secondary: 'bg-white/10 text-white border border-white/15 backdrop-blur-sm hover:bg-white/15',
            ghost: 'text-white/80 hover:text-white hover:bg-white/10',
            link: 'text-white/80 underline-offset-4 hover:text-white hover:underline',
        },
        size: {
            default: 'h-10 px-5 py-2',
            sm: 'h-9 rounded-lg px-3 text-xs',
            lg: 'h-12 rounded-lg px-8 text-sm',
            icon: 'h-10 w-10',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});
const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (_jsx(Comp, { className: cn(buttonVariants({ variant, size, className })), ref: ref, ...props }));
});
Button.displayName = 'Button';
export { Button, buttonVariants };
//# sourceMappingURL=button.js.map